<template>
    <div class="upload-facial-record-wrapper" v-loading="loading">
        <div class="breadcrumb">人脸导入记录
            <el-button class="right_f" type="primary" @click="goback">返回</el-button>
        </div>

        <div class="com-list">
            <el-table v-show="recordData.length > 0" :data="recordData">
                <el-table-column align="center" label="序号" type="index" width="80"></el-table-column>
                <el-table-column align="center" label="上传时间" prop="stuId">
                    <template scope="{row}">
                        {{ $util.dateFormat(new Date(row.importTime), 'yyyy-MM-dd hh:mm:ss') }}
                    </template>
                </el-table-column>
                <el-table-column align="center" label="文件夹名称" prop="name"></el-table-column>
                <el-table-column align="center" label="照片数量" prop="totalLine"></el-table-column>
                <el-table-column align="center" label="已处理数量" prop="handleLine"></el-table-column>
                <el-table-column align="center" label="上传失败数量" prop="incorrectLine"></el-table-column>
                <el-table-column align="center" label="操作" width="200">
                    <template scope="{row}">
                        <el-button v-if="row.incorrectLine > 0" type="text" @click="clickDetail(row)">查看详情</el-button>
                        <span v-else>--</span>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <el-pagination v-show="total > 0" layout="prev, pager, next" :page-size='pageSize' :total="total"
            :current-page="pageNum" @current-change="handleCurrentChange">
        </el-pagination>
    </div>
</template>

<script>
export default {
    data() {
        return {
            loading: false,
            rootUnid: '',
            recordData: [],
            total: 0,
            pageNum: 1,
            pageSize: 20
        }
    },

    mounted() {
        this.rootUnid = this.$route.query.rootUnid;
        this.queryRecordList();
    },

    methods: {
        // 获取记录列表
        queryRecordList() {
            this.loading = true;
            this.$http({
                url: this.$util.domain + '/adminapi/v1/user/face/upload/list',
                method: 'POST',
                body: JSON.stringify({
                    rootUnid: this.rootUnid,
                    pageSize: this.pageSize,
                    pageNum: this.pageNum
                })
            }).then((res) => {
                if (res.data.error == 10000) {
                    this.recordData = res.data.data.models || [];
                    this.total = res.data.data.total || 0;
                } else {
                    this.recordData = [];
                    this.total = 0;
                }
            }).catch((err) => {
                this.recordData = [];
                this.total = 0;
                this.$util.errorMsg('获取列表失败');
            }).finally(() => {
                this.loading = false;
            });
        },

        // 返回
        goback() {
            history.back();
        },

        //  点击查看详情
        clickDetail(row) {
            this.$util.refreshTo("/#/user/facial/detail", { taskId: row.taskId });
        },

        // 分页切换
        handleCurrentChange(val) {
            this.pageNum = val;
            this.queryRecordList();
        },
    }
}
</script>

<style scoped>
.upload-facial-record-wrapper {
    display: block;
}
</style>


// WEBPACK FOOTER //
// UploadFacialRecord.vue?4065c606